/**
 * Vue.js міксин для відстеження кліків по товарах
 * Використовується в компонентах, які відображають списки товарів
 */
import ProductClickTracker from '@/utils/productClickTracker';
export default {
    data() {
        return {
            productClickTracker: null
        };
    },
    mounted() {
        // Використовуємо глобальний трекер замість створення нового для кожного компонента
        this.initProductClickTracker();
    },
    beforeDestroy() {
        // Не скидаємо глобальний трекер при знищенні компонента
        // this.productClickTracker.reset();
    },
    methods: {
        /**
         * Ініціалізує відстеження кліків по товарах
         * @param {string} listName - Назва списку товарів
         * @param {string} listId - ID списку товарів
         */
        initProductClickTracker(listName = 'Product Card', listId = 'product-card') {
            // Використовуємо глобальний трекер замість створення нового
            if (!window.__globalProductClickTracker) {
                window.__globalProductClickTracker = new ProductClickTracker();
            }
            
            this.productClickTracker = window.__globalProductClickTracker;
            this.productClickTracker.setListContext(listName, listId);
        },
        /**
         * Очищає відстеження кліків (корисно при зміні сторінки)
         */
        resetClickTracking() {
            if (this.productClickTracker) {
                this.productClickTracker.reset();
            }
        },
        /**
         * Обробляє клік по товару
         * @param {Object} product - Дані товару
         */
        handleProductClick(product) {
            console.log('🎯 handleProductClick в міксині викликано для товару:', product?.title, product?.id);
            if (this.productClickTracker) {
                this.productClickTracker.handleProductClick(product);
            } else {
                console.error('❌ ProductClickTracker не ініціалізовано!');
            }
        },
        /**
         * Сумісність зі старими викликами в компонентах (trackProductClicks).
         * @param {Array} products
         */
        trackProductClicks(products = []) {
            if (!Array.isArray(products) || products.length === 0) {
                return;
            }
            if (!this.productClickTracker) {
                this.initProductClickTracker();
            }
            // Реєструємо контекст; кліки відправляються з handleProductClick на сам клік.
            this.productClickTracker?.setListContext('Product Card', 'product-card');
        },
        /**
         * Очищає глобальний трекер
         */
        clearGlobalClickTracker() {
            if (this.productClickTracker) {
                this.productClickTracker.clearGlobalTracker();
            }
        },
        /**
         * Очищає стан конкретного товару
         */
        clearProductClickState(productId) {
            if (this.productClickTracker) {
                this.productClickTracker.clearProductState(productId);
            }
        },
        /**
         * Отримує стан глобального трекера
         */
        getGlobalClickTrackerState() {
            if (this.productClickTracker) {
                return this.productClickTracker.getGlobalTrackerState();
            }
            return null;
        }
    }
};
